/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/AssociatedAutomation/Component/AssociatedAutomationControl" />
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import * as Utils_String from "VSS/Core/Util/String";
import { Observer } from "VSSUI/Observer";
import { ObservableValue } from "VSS/Core/Observable";
import * as Constants from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/AssociatedAutomation/Component/AssociatedAutomationControlConstants";
import * as Resources from "Test/TestPlansHubRefresh/TestCaseWorkItemControls/AssociatedAutomation/Resources";

export interface IAssociatedAutomationControlProps extends IVssComponentProperties {
    workItem: IWorkItem;
}

export class AssociatedAutomationControl extends VssComponent<IAssociatedAutomationControlProps, IVssComponentContext> {
    private _automatedTestName: ObservableValue<string> = new ObservableValue<string>("");
    private _automatedTestStorage: ObservableValue<string> = new ObservableValue<string>("");
    private _automatedTestType: ObservableValue<string> = new ObservableValue<string>("");
    private _automatedTestId: string;
    private _disableButtonFlag: boolean;

    constructor(props: IAssociatedAutomationControlProps, context: IVssComponentContext) {
        super(props);
        this._refreshState();
    }

    public render(): JSX.Element {
        return (
            <Observer automatedTestName={this._automatedTestName} automatedTestStorage={this._automatedTestStorage} automatedTestType={this._automatedTestType}>
                {(props: { automatedTestName: string; automatedTestStorage: string; automatedTestType: string }) => {
                    return (
                        <div className="automation-control">
                            <div className="workitemcontrol-label">{Resources.AutomatedTestName}</div>
                            <div className="automation-info">{props.automatedTestName}</div>
                            <div className="workitemcontrol-label">{Resources.AutomatedTestStorage}</div>
                            <div className="automation-info">{props.automatedTestStorage}</div>
                            <div className="workitemcontrol-label">{Resources.AutomatedTestType}</div>
                            <div className="automation-info">{props.automatedTestType}</div>
                            <div className="clear-association-testcase">
                                <button
                                    aria-label={Resources.ClearAutomationDescriptionText}
                                    className="clear-associate-automation-btn"
                                    onClick={this._clearAutomation}
                                    disabled={this._disableButtonFlag}
                                >
                                    {Resources.ClearAssociatedAutomation}
                                </button>
                            </div>
                        </div>
                    );
                }}
            </Observer>
        );
    }

    private _clearAutomation = (): void => {
        this.props.workItem.setFieldValueByName(Constants.AutomatedTestIdFieldName, null);
        let automatedTestAutomationStatusField = this.props.workItem.getFieldByName(Constants.AutomatedTestAutomationStatusFieldName);
        if (automatedTestAutomationStatusField && automatedTestAutomationStatusField.lists) {
            const allowedValues = automatedTestAutomationStatusField.lists.allowedValues;
            if (allowedValues && allowedValues.length > 0 && allowedValues[0].items && allowedValues[0].items.length > 0) {
                this.props.workItem.setFieldValueByName(Constants.AutomatedTestAutomationStatusFieldName, allowedValues[0].items[0]);
            }
        }

        this.props.workItem.setFieldValueByName(Constants.AutomatedTestNameFieldName, null);
        this.props.workItem.setFieldValueByName(Constants.AutomatedTestStorageFieldName, null);
        this.props.workItem.setFieldValueByName(Constants.AutomatedTestTypeFieldName, null);

        this._refreshState();
    };

    private _refreshState = (): void => {
        this._automatedTestName.value = this.props.workItem.getFieldValueByName(Constants.AutomatedTestNameFieldName);
        this._automatedTestStorage.value = this.props.workItem.getFieldValueByName(Constants.AutomatedTestStorageFieldName);
        this._automatedTestType.value = this.props.workItem.getFieldValueByName(Constants.AutomatedTestTypeFieldName);
        this._automatedTestId = this.props.workItem.getFieldValueByName(Constants.AutomatedTestIdFieldName);

        this._disableButtonFlag = this._automatedTestId == null || Utils_String.equals(this._automatedTestId, "");
    };
}
